import {
  DetailedLoanStatusTag,
  DetailedLoanStatusTagProps,
} from '@/components/shared/components/DetailedLoanStatusTag';

interface CheckoutSessionStatusTag extends DetailedLoanStatusTagProps {}

export const CheckoutSessionStatusTag = ({
  status,
  applicationType,
  loanCriteria,
  boxProps,
}: CheckoutSessionStatusTag) => {
  return (
    <DetailedLoanStatusTag
      status={status}
      applicationType={applicationType}
      loanCriteria={loanCriteria}
      boxProps={boxProps}
      hideSubText={true}
    />
  );
};
